import React from "react";
import { FaGlobeEurope, FaMoon, FaSignOutAlt, FaSun } from "react-icons/fa";
import { MdDashboard, MdOutlineMessage } from "react-icons/md";

import AdminIconButton from "../ui/AdminIconButton";

export default function TopBarActions({
  user,
  avatarSrc,
  isLogged,
  mounted,
  theme,
  unreadContactCount,
  onGoToContactMessages,
  onGoToDashboard,
  onGoToPublicSite,
  onToggleTheme,
  onLogout,
}) {
  return (
    <div className="flex items-center gap-2 sm:gap-3">
      <AdminIconButton
        icon={MdOutlineMessage}
        badge={unreadContactCount}
        onClick={onGoToContactMessages}
        title="Messages du formulaire de contact"
        variant="neutral"
      />

      <AdminIconButton
        icon={MdDashboard}
        onClick={onGoToDashboard}
        title="Tableau de bord"
        variant="neutral"
        className="hidden sm:inline-flex"
      />

      <AdminIconButton
        icon={FaGlobeEurope}
        label="Site public"
        onClick={onGoToPublicSite}
        title="Voir le site public"
        variant="primary"
        className="hidden md:inline-flex"
      />

      <AdminIconButton
        icon={mounted && theme === "dark" ? FaSun : FaMoon}
        onClick={onToggleTheme}
        title="Changer le thème"
        variant="neutral"
      />

      {isLogged ? (
        <div
          className="hidden items-center gap-3 rounded-2xl border border-slate-200 bg-white py-1.5 pl-2 pr-3 text-left shadow-sm sm:flex dark:border-slate-700 dark:bg-slate-900"
          title="Utilisateur connecté"
        >
          <img
            src={avatarSrc}
            alt="Avatar utilisateur"
            className="h-10 w-10 rounded-full object-cover ring-2 ring-slate-200 dark:ring-slate-700"
          />

          <div className="hidden min-w-0 lg:block">
            <div className="truncate text-sm font-bold text-slate-950 dark:text-white">
              {user?.prenom || ""} {user?.nom || ""}
            </div>

            <div className="truncate text-xs text-slate-500 dark:text-slate-400">
              Administration mairie
            </div>
          </div>
        </div>
      ) : null}

      {isLogged ? (
        <AdminIconButton
          icon={FaSignOutAlt}
          onClick={onLogout}
          title="Déconnexion"
          variant="danger"
        />
      ) : null}
    </div>
  );
}